"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => ({
    paper: {
        width: '600px',
        height: 'fit-content',
        minHeight: 26,
    },
    paperItem: {
        minHeight: 26,
        lineHeight: '26px',
        padding: '0 10px',
    },
    popper: {
        width: '500px',
        zIndex: 1500,
    },
    icon: {
        marginRight: '2pt',
        padding: 1,
    },
    iconOpened: {
        transform: 'rotate(180deg)',
    },
    wrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.editing,
    },
    wrapperDisabled: {
        backgroundColor: 'inherit',
    },
    chips: {
        marginTop: 3,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    chipsWrapper: {
        flex: 1,
        display: 'flex',
    },
    chip: {
        height: 20,
        whiteSpace: 'break-spaces',
        overflow: 'hidden',
        margin: '0 2px 2px 2px',
    },
    input: {
        flexGrow: 1,
        flexShrink: 1,
        minWidth: '30%',
    },
    delimiter: {
        display: 'inline',
        marginLeft: 10,
    },
    disabledComponent: {
        lineHeight: '22px',
        width: '100%',
    },
}));
//# sourceMappingURL=autocomplate-styles.js.map